/**
 * 前端监控上报逻辑
 *
 * 使用 SLS WebTracking + STS 安全模式上报。
 * 通过后端 /sls/sts-token 接口获取临时凭证，前端不持有长期 AK。
 */
import { initSlsTracker, sendSlsLog } from '../utils/slsTracker';

/**
 * 获取页面类型
 * @param {string} pagePath - 页面路径
 * @returns {string} 页面类型
 */
function getPageType(pagePath) {
  if (!pagePath) {
    return 'unknown';
  }

  if (pagePath.indexOf('/share') !== -1) {
    return 'share';
  }

  if (pagePath.indexOf('/make') !== -1 || pagePath.indexOf('/edit') !== -1 || pagePath.indexOf('/editor') !== -1) {
    return 'editor';
  }

  return pagePath.replace(/\//g, '_');
}

/**
 * 构建监控上下文
 * @returns {object} 监控上下文
 */
function buildFrontendMonitorContext() {
  let pageUrl = '';
  let pagePath = '';

  if (typeof window !== 'undefined' && window.location) {
    pageUrl = window.location.href || '';
    pagePath = window.location.pathname || '';
  }

  return {
    projectType: 'mainloading',
    pageType: getPageType(pagePath),
    pageUrl,
    pagePath,
    mainloadingMode: 'serve',
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent || '' : '',
    timestamp: Date.now()
  };
}

const SLS_STS_TOKEN_URL = 'https://alifun.litiskr.cn/sls/sts-token';

/**
 * 获取 SLS STS 临时凭证
 * @returns {Promise<{AccessKeyId, AccessKeySecret, SecurityToken}>}
 */
async function getSlsSTSToken() {
  const response = await fetch(SLS_STS_TOKEN_URL, {
    method: 'GET',
    credentials: 'omit'
  });

  if (!response.ok) {
    throw new Error(`sts token request failed: ${response.status}`);
  }

  return response.json();
}

/**
 * 初始化 SLS Tracker
 *
 * 使用 STS 安全模式，通过后端 /sls/sts-token 接口获取临时凭证。
 */
initSlsTracker({
  host: 'cn-shenzhen.log.aliyuncs.com',
  project: 'liti-h5-mainloading',
  logstore: 'normal',
  getSTSToken: getSlsSTSToken
});

export function useMonitor() {
  return {
    /**
     * 发送前端监控
     * @param {object} payload - 监控数据
     */
    sendFrontendMonitor(payload) {
      const logData = Object.assign({}, buildFrontendMonitorContext(), payload || {});

      // 实际上报 SLS
      sendSlsLog(logData);
    }
  };
}
